import React, { useEffect, useState } from 'react';
import styled from "@emotion/styled";
import { Row, Col, Spin } from "antd";
import Bdologo from '../../assets/BDO.svg';
import COLORS from '../../common/Colors';
import AddClientSurvey from './AddClientSurvey';
import { CheckCircleFilled } from "@ant-design/icons";
import { Form, message } from "antd";
import { CALL_API } from "common/API";
import { useNavigate } from 'react-router-dom';
import {  Input, Button } from "antd";
const StyledContainer = styled.div`
  overflow-x: hidden;
  padding-bottom: 5%;
  h5{
    margin-bottom: 10px;
  }
  a{
    color: white;
    text-decoration: none;
    margin-bottom: 20px;
  }
  .anticon-check-circle {
    font-size: 4rem;
    display: block;
    padding: 10px;
    color: #2CFF00;
  }
  h3{
    color: ${COLORS.BLACK};
    font-size: 20px;
  }
  .clientSurvey-form {
    margin: 0 !important;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; /* Fixed syntax */
  }
`;

const StyledRow = styled(Row)`
  background-color: ${COLORS.SIDEBAR};
  color: #000;

  img {
    max-width: 100%;
    height: auto;
  }
  .page-title {
    color: #000;
    h4{
        color: #000;
    }
    h1 {
      margin-top: 10px;
      color: #000;
      letter-spacing: 2px;
      font-size: calc(3em + 1vw);
    }
    span {
      margin-top: -2%;
    }
  }
`;

function ClientSurvey() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const getengagementid = urlParams.get("id");
  const getsurveyid = urlParams.get("surveyid");
  const [submitted, setSubmitted] = useState(false);
  const [resmssg, setresmssg] = useState('');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    fetchSurvey();
  }, [])

  const handleClientSurveyFirstForm = async (values) => {
    const filledBy = form.getFieldValue("survey_filled_by"); 
    const data = {
      survey_filled_by: filledBy,
      surveyData: [
        { question: "1. Were the service timely?", answer: values.service_timely },
        { question: "2. Were the staff responsive and knowledgeable?", answer: values.staff_responsive },
        { question: "3. Was the methodology, technology and analysis used of high quality?", answer: values.value_for_money },
        { question: "4. Did you get value for money from the service?", answer: values.recommend },
        { question: "5. Would you continue using BDO and recommend them to a friend or colleague?", answer: values.quality },
        { question: "6. Comment", answer: values.comment ?? "" },
        { question: "7. Would you be able to give us a recommendation letter?", answer: values.recommendation_letter },
      ],
      surveyId: parseInt(getsurveyid),
    };
    setLoading(true); 
    try {
      const response = await CALL_API(`insyts/engagement/client-survey?engagementId=${getengagementid}`,"POST",data);
      if (response.code === "SUCCESS") {
        form.resetFields();
        setresmssg(response?.message);
        setSubmitted(true);
        navigate(window.location.pathname, { replace: true }); 
      } else {
        message.error("Failed to submit survey");
      }
    } catch (error) {
      message.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (values) => {
    handleClientSurveyFirstForm(values);
  };

  const fetchSurvey = async () => {
    try {
      setLoading(true); 
      const payload = {
        engagementId: getengagementid,
        surveyId: parseInt(getsurveyid),
        status: true,
      };
      const response = await CALL_API(`insyts/engagement/client-survey`, "POST", payload);
      if (response.code === "SUCCESS") {
        if (response.message) {
          setresmssg(response.message);
        } else {
          setresmssg("No data available");
        }
      } else {
        message.error("Failed to fetch survey");
      }
    } catch (error) {
      message.error("An error occurred");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <StyledContainer>
      <StyledRow gutter={8} className='px-5'>
        <div className='py-4'>
          <Row >
            <Col  md={24} sm={24} lg={24} className="page-title">
              <div className='text-left mt-0'>
                <img src={Bdologo} alt="logo" />
              </div>
            </Col>
            {!submitted ? (
              <Col md={24} sm={24} lg={24} className="page-title">
                <div className='text-left' style={{backgroundColor: "#3399ff"}}>
                  <h4 className='mt-3 p-2'>Client survey</h4>
                </div>
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                  <Spin spinning={loading} size="large">
                    <Row gutter={16} className='clientSurvey-form'>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}   span={24}>
                        <p>Name:</p>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}  span={24}>
                          <div style={{textAlign:"left"}}>
                            <span style={{ fontWeight: "bold" ,width:"50%"}}>{resmssg?.clientname ? resmssg?.clientname : "NoName"}</span>
                          </div>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}   span={24}>
                        <p>Engagement:</p>{" "}
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}  span={24}>
                        <span style={{ fontWeight: "bold" }}>
                          {resmssg?.engagementname
                            ? resmssg?.engagementname
                          : "NoName"}
                        </span>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}   span={24}>
                      <p>Partner In charge and Staff on the job:</p>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}  span={24}>
                        <span style={{ fontWeight: "bold" }}>
                          {resmssg?.managingpartnername ? resmssg?.managingpartnername : "NoName"}
                        </span>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}  span={24}>
                        <p>Name and Designation of person who filled this survey:</p>
                      </Col>
                      <Col xs={24} sm={12} md={12} lg={12} xl={12}  span={24}>
                        <Form.Item 
                          name="survey_filled_by" 
                          rules={[{ required: true, message: "Please enter name & designation" }]}
                        >
                          <Input name="survey_filled_by" 
                            placeholder="Enter name & designation" />
                        </Form.Item>  
                      </Col>
                    </Row>
                  </Spin>
                </Form>
              </Col>
            ) : (
              ""
            )}
          </Row>
        </div>
      </StyledRow>
      <div className="px-5">
        {!submitted ? (
          <div style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", padding: 10 }}>
            <div>
              <p style={{ marginBottom: 0, fontWeight: "bold", color: "red" }}>Rating Scale</p>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>Performance</span>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>1. Strongly Disagree</span>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>2. Disagree</span>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>3 = Neutral</span>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>4 = Agree</span>
              <span style={{ marginRight: 20, fontWeight: "bold" }}>5 = Strongly Agree</span>
            </div>
            <AddClientSurvey form={form} handleClientSurveyFirstForm={handleClientSurveyFirstForm} loading={loading} resmssg={resmssg} />
          </div>
        ) : (
          <div className="text-center mt-5">
            <br />
            <CheckCircleFilled />
            <h3>{resmssg}</h3>
          </div>
        )}
      </div>
    </StyledContainer>
  );
}

export default ClientSurvey;